import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import QuestionnaireResultsModal from './QuestionnaireResultsModal';

interface Props {
	patientId: string;
	questionnaireCode: string;
	questionnaireName: string;
}

const QuestionnaireResultsButton: React.FC<Props> = ({
	patientId,
	questionnaireCode,
	questionnaireName,
}) => {
	const [isResultOpen, setIsResultOpen] = useState(false);

	return (
		<>
			<LinkButton
				title='base.results'
				theme={Theme.BLUE}
				onClick={() => setIsResultOpen(true)}
			/>
			<QuestionnaireResultsModal
				isOpen={isResultOpen}
				onClose={() => {
					setIsResultOpen(false);
				}}
				patientId={patientId}
				questionnaireName={questionnaireName}
				questionnaireCode={questionnaireCode}
			/>
		</>
	);
};

export default QuestionnaireResultsButton;
